/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ApiAuthUserFromJSON, ApiCreateUpdateUserRequestToJSON, ApiListEnvsResponseFromJSON, ApiListUserClientsResponseFromJSON, ApiListUserProjectsResponseFromJSON, ApiListUsersResponseFromJSON, InlineObject11ToJSON, } from '../models';
/**
 *
 */
export class UserServiceApi extends runtime.BaseAPI {
    /**
     */
    userServiceCreateUserRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling userServiceCreateUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/users/user`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiCreateUpdateUserRequestToJSON(requestParameters.body),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiAuthUserFromJSON(jsonValue));
        });
    }
    /**
     */
    userServiceCreateUser(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userServiceCreateUserRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    userServiceDeleteUserRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userId === null || requestParameters.userId === undefined) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling userServiceDeleteUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/users/user/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    userServiceDeleteUser(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userServiceDeleteUserRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    userServiceGetAuthUserRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/auth-user`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiAuthUserFromJSON(jsonValue));
        });
    }
    /**
     */
    userServiceGetAuthUser(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userServiceGetAuthUserRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * these are just users that belong to a project
     */
    userServiceListProjectUsersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling userServiceListProjectUsers.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/users/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListUsersResponseFromJSON(jsonValue));
        });
    }
    /**
     * these are just users that belong to a project
     */
    userServiceListProjectUsers(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userServiceListProjectUsersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    userServiceListUserClientsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.env !== undefined) {
                queryParameters['env'] = requestParameters.env;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/users/clients`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListUserClientsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    userServiceListUserClients(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userServiceListUserClientsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    userServiceListUserEnvsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.env !== undefined) {
                queryParameters['env'] = requestParameters.env;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/users/envs`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListEnvsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    userServiceListUserEnvs(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userServiceListUserEnvsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    userServiceListUserProjectsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.env !== undefined) {
                queryParameters['env'] = requestParameters.env;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/users/projects`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListUserProjectsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    userServiceListUserProjects(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userServiceListUserProjectsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Users here
     */
    userServiceListUsersRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/users/user`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListUsersResponseFromJSON(jsonValue));
        });
    }
    /**
     * Users here
     */
    userServiceListUsers(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userServiceListUsersRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    userServiceReadUserRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userId === null || requestParameters.userId === undefined) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling userServiceReadUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/users/user/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiAuthUserFromJSON(jsonValue));
        });
    }
    /**
     */
    userServiceReadUser(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userServiceReadUserRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * note, this method has a lot of business logic around it, if you just want to change part of user patch user
     */
    userServiceUpdateUserRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userId === null || requestParameters.userId === undefined) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling userServiceUpdateUser.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling userServiceUpdateUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/users/user/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InlineObject11ToJSON(requestParameters.body),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiAuthUserFromJSON(jsonValue));
        });
    }
    /**
     * note, this method has a lot of business logic around it, if you just want to change part of user patch user
     */
    userServiceUpdateUser(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userServiceUpdateUserRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
